export const WA_PHONE = "966567352845"; // international format, no + or 0
export const WA_DISPLAY = "0567352845";
export const EMAIL = "info@talibnaz.com";

export const buildWaLink = (message = "") => {
  const encoded = encodeURIComponent(message.trim());
  return `https://wa.me/${WA_PHONE}${encoded ? `?text=${encoded}` : ""}`;
};
